export default (type) => {
	let now = new Date();
	let date = new Date(type);
	let inter = parseInt((date.getTime() - now.getTime()) / 1000 / 60);
	return inter >= 0 ? true : false;
};
